import { ConfigOption } from '@ngx-formly/core';
import { HarbourDropDownComponent } from './controls/harbour-drop-down/harbour-drop-down.component';

export const HARBOUR_FORMLY_TYPES: ConfigOption['types'] = [
  { name: 'formly-harbour-drop-down', component: HarbourDropDownComponent, wrappers: ['simple-title'] },
]
